export interface Rollouts {
    [key: string]: boolean;
}

export const ROLLOUTS = {
    GRIZZLIES_TRADER_DETAILS_DISPLAYING: 'grizzlies_trader_details_displaying',
    QUALAS_NEW_LEVEL_SYSTEM_CONSUMERS_MIGRATION: 'qualas_new_level_system_consumers_migration',
    QUALAS_LOG_UNKNOWN_CRAWLERS_ON_SELLER_PAGE: 'qualas_log_unknown_crawlers_on_seller_page',
    ZEBRAS_HOURLY_RATES: 'zebras_hourly_rate',
    CHEETAHS_SELLER_ROLE_PAGE_RELEASE_TWO: 'cheetahs_seller_role_page_release_two',
    STARLINGS_BOOSTING_NEW_GIGS: 'starlings_boosting_new_gigs',
    STARLINGS_FIVERR_GO_FLOATING_CHAT: 'starlings_fiverr_go_floating_chat',
    STARLINGS_FIVERR_GO_INBOX: 'starlings_fiverr_go_inbox',
    CARIBOU_PORTFOLIO_ATTACHMENT_REPORT_ELIGIBILITY: 'caribou_portfolio_attachment_report_eligibility',
    ZEBRAS_NEW_LOYALTY_POINTS: 'zebras_new_loyalty_points',
    COBRAS_OPEN_HOURLY_TO_MP: 'cobras_open_hourly_to_mp',
    MARLINS_SELLER_PAGE_DES_BANNER: 'marlins_seller_page_des_banner',
    MARLINS_SELLER_PAGE_MULTI_BANNER: 'marlins_seller_page_multi_banner',
    PIGLETS_ENABLE_PRICE_UPFRONT: 'piglets_enable_price_upfront_display',
};
